import { axios } from '@/services/axios';

/**
 * Fetch the list of number block orders (requests).
 *
 * Filters by whichever identity is active for the current scope
 * (WholesalerID, PartnerID, or CompanyID query params); omitted when falsy.
 *
 * @param {object} params
 * @param {string} [params.wholesalerID] - Filter by Wholesaler ID (sent as WholesalerID; omitted when falsy)
 * @param {string} [params.partnerID] - Filter by Partner ID (sent as PartnerID; omitted when falsy)
 * @param {string} [params.companyID] - Filter by Company ID (sent as CompanyID; omitted when falsy)
 * @param {number} params.scope - Request scope (20, 40, 60, or 80); sent as X-RequestScope
 * @param {number} [params.page=0] - Zero-based page index
 * @param {number} [params.pageSize=20] - Page size
 * @param {number} [params.status] - 0=Completed, 1=Queued, 4=Processing, 20=Errored, 21=Cancelled
 */
export const getNumberBlockOrders = ({
    wholesalerID,
    partnerID,
    companyID,
    scope,
    page = 0,
    pageSize = 20,
    status,
} = {}) =>
    axios.get('/NumberBlock/Requests', {
        headers: { 'X-RequestScope': scope },
        params: {
            ...(wholesalerID ? { WholesalerID: wholesalerID } : {}),
            ...(partnerID ? { PartnerID: partnerID } : {}),
            ...(companyID ? { CompanyID: companyID } : {}),
            page,
            pageSize,
            ...(status !== undefined && status !== null ? { status } : {}),
        },
    });
